<template>
  <div>
    <a-form-model :model="relsForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="relsRules" ref="relsForm">
      <a-divider />
      <a-form-model-item label="设备类型" v-if="deviceTypeOptions" prop="deviceTypeId">
        <a-select
          v-model="relsForm.deviceTypeId"
          allowClear
          placeholder="请选择设备类型"
          style="width: 320px"
          @change="handleChange"
        >
          <a-select-option v-for="deviceType in deviceTypeOptions" :key="deviceType.deviceTypeId">{{
            deviceType.name
          }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div>
        <a-form-model-item label="品牌" prop="brandSelect">
          <a-select
            v-model="relsForm.brandSelect"
            mode="multiple"
            label-in-value
            showSearch
            allowClear
            showArrow
            placeholder="请选择品牌"
            style="width: 320px"
          >
            <a-select-option v-for="brand in brandList" :key="`${brand.name}-${brand.brandId}`">{{
              brand.name
            }}</a-select-option>
          </a-select>
          <!-- <a-select
            show-search
            label-in-value
            allowClear
            v-model="relsForm.brandSelect"
            mode="multiple"
            placeholder="请输入品牌关键字"
            style="width: 320px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearch"
          >
            <a-select-option v-for="brand in brandList" :key="`${brand.name}-${brand.brandId}`">{{
              brand.name
            }}</a-select-option>
          </a-select> -->
        </a-form-model-item>
      </div>
      <div v-if="districtList">
        <a-form-model-item label="服务商所在省份" v-if="districtList" prop="districtCode">
          <a-select
            v-model="relsForm.districtCode"
            allowClear
            placeholder="请选择服务商所在省份"
            style="width: 320px"
            @change="districtChange"
          >
            <a-select-option v-for="district in districtList" :key="district.districtCode">{{
              district.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="服务商所在城市" v-if="cityList" prop="districtCityCode">
          <a-select
            v-model="relsForm.districtCityCode"
            allowClear
            placeholder="请选择服务商所在城市"
            style="width: 320px"
            @change="cityChange"
          >
            <a-select-option v-for="city in cityList" :key="city.districtCode">{{ city.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="服务商" v-if="serviceProviderList" prop="providerSelect">
          <a-select
            mode="multiple"
            v-model="relsForm.providerSelect"
            allowClear
            showSearch
            placeholder="请选择服务商"
            style="width: 320px"
          >
            <a-select-option
              v-for="provider in serviceProviderList"
              :key="`${provider.serviceProviderId}-${provider.name}`"
              >{{ provider.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
      </div>
      <!-- <a-form-model-item label="优先级">
        <a-input style="width: 320px" v-model="rank" />
      </a-form-model-item> -->
      <a-divider />
    </a-form-model>
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="form">
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="频率" prop="frequency">
        <a-input v-model="form.frequency" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea
          v-model="form.remark"
          placeholder="码库备注"
          :auto-size="{ minRows: 10, maxRows: 20 }"
          size="large"
        />
      </a-form-model-item>
      <remote-controller
        :deviceTemplate="pulseInfo"
        :form="form"
        :deviceTypeId="deviceTypeId"
        v-if="relsForm.deviceTypeId"
      ></remote-controller>
      <a-form-item class="group-btn">
        <a-button type="primary" @click="createRemoteController">确定</a-button>
        <a-button class="creator-btn" @click="cancel">取消</a-button>
      </a-form-item>
    </a-form-model>
  </div>
</template>

<script>
import RemoteController from '../../../components/remote-controller/RemoteController';

export default {
  name: 'RemoteControllerCreator',
  components: { RemoteController },
  mounted() {
    this.getDeviceTypes();
    this.getBrands();
  },
  data() {
    return {
      relsForm: {
        brandSelect: [],
        districtCityCode: undefined,
      },
      relsRules: {
        deviceTypeId: [{ required: true, message: '设备类型 不能为空', trigger: 'change' }],
        brandSelect: [{ required: true, message: '品牌绑定 不能为空', trigger: 'change' }],
        districtCode: [{ required: true, message: '服务商所在省份 不能为空', trigger: 'change' }],
        districtCityCode: [{ required: true, message: '服务商所在城市 不能为空', trigger: 'change' }],
        providerSelect: [{ required: true, message: '服务商 不能为空', trigger: 'change' }],
      },
      rules: {
        name: [{ required: true, message: '码库名称 不能为空', trigger: 'blur' }],
        frequency: [{ required: true, message: '频率 不能为空', trigger: 'blur' }],
        remark: [{ required: true, message: '备注 不能为空', trigger: 'blur' }],
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      deviceTypeId: null,
      deviceTypeOptions: null,
      districtList: null,
      cityList: null,
      serviceProviderList: null,
      brandList: null,
      brandRemoteRels: [],
      pulseInfo: undefined,
      regionId: null,
      form: {
        keys: [],
        modes: null,
      },
    };
  },
  watch: {
    editable: {},
  },
  methods: {
    async getBrands() {
      const response = await this.$apiManager.brand.getBrands({ unpaged: true });
      this.brandList = response.data.elements;
    },
    async handleSearch(value) {
      const params = {
        unpaged: true,
        name: value,
      };
      const response = await this.$apiManager.brand.getBrands(params);
      this.brandList = response.data.elements;
    },
    handleChange(value) {
      this.form = {
        keys: [],
        modes: null,
      };
      this.districtList = null;
      this.relsForm.brandSelect = [];
      this.cityList = null;
      this.serviceProviderList = null;
      this.deviceTypeId = value;
      this.infraredtemplates(value);
      if (this.deviceTypeId === this.$constRepository.deviceType.DEVICE_TYPE['机顶盒']) {
        this.$apiManager.district.getDistrict().then((district) => {
          this.districtList = district.data;
        });
      }
    },
    infraredtemplates(value) {
      this.pulseInfo = [];
      this.$apiManager.deviceType.infraredtemplates(value).then((template) => {
        this.pulseInfo = template.data.keys;
      });
    },
    districtChange(value) {
      this.cityList = null;
      this.relsForm.districtCityCode = null;
      this.serviceProviderList = null;
      this.$apiManager.district.getCity(value).then((district) => {
        this.cityList = district.data;
      });
    },
    cityChange(value) {
      this.serviceProviderList = null;
      this.regionId = value;
      this.$apiManager.serviceProvider.getServiceProviders({ unpaged: true }).then((provider) => {
        this.serviceProviderList = provider.data.elements;
      });
    },
    cancel() {
      this.$router.back();
    },
    providerRels(remoteResponse) {
      const providerList = [];
      this.relsForm.providerSelect.forEach((provider) => {
        const params = {
          spRemoteRelId: this.$uuid.v4(),
          remoteId: remoteResponse.remoteControllerId,
          serviceProviderId: provider.split('-')[0],
          regionId: this.regionId,
          rank: 0,
        };
        providerList.push(params);
      });
      this.$apiManager.remoteControllers
        .createSpRemoteRels(providerList)
        .then(() => {})
        .catch(() => {});
    },
    brandRels(remoteResponse) {
      this.relsForm.brandSelect.forEach((brand) => {
        const params = {
          deviceTypeId: this.deviceTypeId,
          remoteId: remoteResponse.remoteControllerId,
          brandId: brand.key.split('-')[1],
          rank: 0,
          brandRemoteRelId: this.$uuid.v1(),
        };
        this.brandRemoteRels.push(params);
      });
      this.$apiManager.remoteControllers
        .createBrandRemoteRels(this.brandRemoteRels)
        .then(() => {
          this.$router.back();
        })
        .catch(() => {});
    },
    async createRelsAndRemote() {
      let remoteResponse;
      await this.$apiManager.remoteControllers
        .createRemoteController(this.form)
        .then((response) => {
          remoteResponse = response.data;
          this.$message.success('创建成功');
        })
        .catch(() => {});
      if (this.deviceTypeId && this.deviceTypeId === this.$constRepository.deviceType.DEVICE_TYPE['机顶盒']) {
        await this.providerRels(remoteResponse);
        this.brandRels(remoteResponse);
      } else {
        this.brandRels(remoteResponse);
      }
    },
    async createRemoteController() {
      this.$refs.relsForm.validate((relsValid) => {
        if (relsValid) {
          this.$refs.form.validate((formValid) => {
            if (formValid) {
              this.createRelsAndRemote();
            }
          });
        } else {
          this.$message.warn('基础信息存在未填写的数据');
        }
      });
    },
    createBrand() {
      this.$apiManager.brand
        .createBrands(this.form)
        .then(() => {
          this.$message.success('创建成功');
          this.$router.back();
        })
        .catch(() => {});
    },
    async getDeviceTypes() {
      const params = {
        unpaged: true,
      };
      const deviceTypeResponse = await this.$apiManager.deviceType.getDeviceTypes(params);
      this.deviceTypeOptions = deviceTypeResponse.data.elements;
    },
  },
};
</script>

<style lang="less" scoped>
.add-btn {
  float: right;
  z-index: 100;
  margin-bottom: 1%;
}
.edit-btn {
  color: green;
}
.delete-btn {
  color: red;
}
.creator-btn {
  margin-left: 5%;
}
.service-provicer-operations {
  display: flex;
  .add-btn {
    margin: 10px 0px;
    margin-left: 3%;
  }
  .service-table {
    margin-top: 2%;
  }
}
.group-btn {
  margin-left: 16.7%;
}
.vue-xlsx-container {
  .xlsx-button {
    width: 10%;
  }
}
.editable-add-btn {
  float: right;
  margin: 5px 0px;
}
label {
  position: relative;
}
#fileinp {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
#btn {
  margin-right: 5px;
  border-color: #78c3f3;
  text-decoration: none;
  position: relative;
  display: inline-block;
  background: #d0eeff;
  border: 1px solid #99d3f5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
}
.expand-tab {
  margin-top: 2%;
}
</style>
